// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1p7Sl","item":"PaymentsMobile_item__33oLR","label":"PaymentsMobile_label__1Qle5","amount":"PaymentsMobile_amount__p7Nmx"};